import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  background-color: #FFF;
  border: 1px solid #00A988;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 303px;
  min-height: 303px;
  max-width: 280px;
  min-width: 280px;
  padding: 32px 24px;

  & > figure {
    max-width: fit-content;

    & > img {
      width: 100%;
    }
  }

  @media (max-width: 568px) {
    gap: 8px;
    max-height: 210px;
    min-height: 210px;
    max-width: 180px;
    min-width: 180px;
    padding: 16px;

    & > figure {
      max-width: 120px;
    }
  }
`
